import api from "../api/flexapi";
import lodash from "lodash";

// Load Data Action Types
export const hraInputQuestionnaireLoadBegin =
  "HRA_INPUT_QUESTIONARIE_LOAD_BEGIN";
export const hraInputQuestionnaireLoadSuccess =
  "HRA_INPUT_QUESTIONARIE_LOAD_SUCCESS";
export const hraInputQuestionnaireLoadFailed =
  "HRA_INPUT_QUESTIONARIE_LOAD_FAILED";

// Call API to load module data
export const load = () => dispatch => {
  dispatch({ type: hraInputQuestionnaireLoadBegin, payload: null });
  return api
    .getHraQuestionnaire()
    .then(response => {
      //getHraQuestionnaire

      response.body.sections = Array.isArray(response.body.sections.section)
        ? response.body.sections.section
        : [response.body.sections.section];
      response.body.sections.forEach(section => {
        section.subsections = Array.isArray(section.subsections.subsection)
          ? section.subsections.subsection
          : [section.subsections.subsection];
        section.subsections.forEach(subsection => {
          subsection.questions = Array.isArray(subsection.questions.question)
            ? subsection.questions.question
            : [subsection.questions.question];
          subsection.questions.forEach(question => {
            if (!question) {
              return;
            }
            if (lodash.get(question, "questionOptions.questionOption")) {
              question.questionOptions = Array.isArray(
                question.questionOptions.questionOption
              )
                ? question.questionOptions.questionOption
                : [question.questionOptions.questionOption];
            } else {
              question.questionOptions = [];
            }
            if (question.units) {
              question.units = Array.isArray(question.units.unit)
                ? question.units.unit
                : [question.units.unit];
            }
          });
        });
      });

      dispatch({
        type: hraInputQuestionnaireLoadSuccess,
        payload: response.body,
      });
    })
    .catch(err => {
      dispatch({
        type: hraInputQuestionnaireLoadFailed,
        payload: err.response ? err.response.body : err,
      });
    });
};

// Post Data Action Types
export const hraInputQuestionnairePostBegin =
  "HRA_INPUT_QUESTIONARIE_POST_BEGIN";

// Post data
export const submit = (isComplete, sectionTag, data) => dispatch => {
  dispatch({ type: hraInputQuestionnairePostBegin, payload: null });
  const modifiedData = {};

  Object.keys(data).forEach(key => {
    if (key.startsWith("question_")) {
      const temp = data[key];
      const newKey = key.replace("question_", "");
      modifiedData[newKey] = temp ? temp.toString() : "";
    } else {
      modifiedData[key] = data[key] ? data[key].toString() : "";
    }
  });

  return new Promise((resolve, reject) => {
    api
      .postHraQuestionnaireAnswers(isComplete, sectionTag, modifiedData)
      .then(response => {
        resolve(response.body);
      })
      .catch(() => {
        reject();
        //throw new SubmissionError({ questionId: "error message", _error: error.message });
      });
  });
};

export const hraInputQuestionnaireSelectBodyPartFront =
  "HRA_INPUT_QUESTIONARIE_SELECT_BODY_PART_FRONT";
export const hraInputQuestionnaireSelectBodyPartBack =
  "HRA_INPUT_QUESTIONARIE_SELECT_BODY_PART_BACK";
export const hraInputQuestionnaireDeselectBodyPartFront =
  "HRA_INPUT_QUESTIONARIE_DESELECT_BODY_PART_FRONT";
export const hraInputQuestionnaireDeselectBodyPartBack =
  "HRA_INPUT_QUESTIONARIE_DESELECT_BODY_PART_BACK";

export const selectFrontBodyPart = bodyPart => dispatch =>
  dispatch({
    type: hraInputQuestionnaireSelectBodyPartFront,
    payload: bodyPart,
  });
export const selectBackBodyPart = bodyPart => dispatch =>
  dispatch({
    type: hraInputQuestionnaireSelectBodyPartBack,
    payload: bodyPart,
  });
export const deselectFrontBodyPart = bodyPart => dispatch =>
  dispatch({
    type: hraInputQuestionnaireDeselectBodyPartFront,
    payload: bodyPart,
  });
export const deselectBackBodyPart = bodyPart => dispatch =>
  dispatch({
    type: hraInputQuestionnaireDeselectBodyPartBack,
    payload: bodyPart,
  });



// WEBPACK FOOTER //
// ./actions/hraInputQuestionnaireActions.jsx